// extracted by mini-css-extract-plugin
export default {"placeholderAttribute":"data-ai-compose"};